<template>
  <div>
    <action-alert :type="alert.type" :icon="alert.icon" :is-visible="alert.isVisible">{{alert.text}}</action-alert>
    <SavedSearches :apply="applyQuery" :remove="removeSavedQuery" ref="savedSearches"></SavedSearches>
    <div class="container-fluid">
      <Breadcrumb :values="{ Home: '/', CICS: '' }"></Breadcrumb>
      <div class="animated fadeIn">
        <div>
          <CicsFilters :fields="filterFields" :searchData="searchData"
                       :parseData="parseDataForSearch"
                       :saveFilters="saveQuery" :saveMessage="saveMessage" :toggleSavedSearches="toggleSavedSearches"
                       :showSavedSearches="showSavedSearches" ref="filters"></CicsFilters>
        </div>
        <div class="animated fadeIn">
          <div class="col-12 px-0">
            <template v-if="showTabs">
              <CicsList v-if="cicsData.length" :data="cicsData"></CicsList>
              <div v-else class="card">
                <div class="card-body d-flex justify-content-center align-items-center">
                  <i v-if="ready">No data</i>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../components/shared/Breadcrumb'
import SavedSearches from '../components/Search/SavedSearches'
import CicsFilters from '../components/CICS/CicsFilters'
import { mapActions, mapGetters } from 'vuex'
import studiesActions from '../store/modules/studies/actionTypes'
import generalActions from '../store/modules/general/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import generalGetters from '../store/modules/general/getterTypes'
import CicsList from '../components/CICS/CicsList'
import _ from 'lodash'
import ActionAlert from '../components/shared/ActionAlert'

export default {
  name: 'CICS',
  components: {
    ActionAlert,
    CicsList,
    CicsFilters,
    SavedSearches,
    Breadcrumb
  },
  data () {
    return {
      showTabs: false,
      filterFields: {},
      showSavedSearches: false,
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      },
      ready: true,
      saveMessage: {
        error: false,
        value: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      filterValues: studiesGetters.GET_CICS_FILTERS,
      saved_searches: studiesGetters.GET_SAVED_SEARCHES,
      isSidebarToggled: generalGetters.GET_SIDEBAR_STATE,
      cicsData: studiesGetters.GET_CICS_QUESTIONS
    })
  },
  methods: {
    ...mapActions({
      applySearch: studiesActions.APPLY_SEARCH_FILTERS,
      deleteSearch: studiesActions.DELETE_SAVED_SEARCH,
      getCicsFields: studiesActions.FETCH_CICS_FIELDS,
      getSavedSearches: studiesActions.FETCH_SAVED_SEARCHES,
      getData: studiesActions.FETCH_CICS_QUESTIONS,
      resetStoreFilters: studiesActions.RESET_CICS_FILTERS,
      saveSearch: studiesActions.POST_SAVED_SEARCH,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    applyQuery (search) {
      this.applySearch(JSON.parse(search.metadata_query))
      this.$refs.filters.refreshFilters()
    },
    toggleSavedSearches () {
      this.$refs.savedSearches.toggle()
      this.showSavedSearches = !this.showSavedSearches
    },
    parseDataForSearch (data) {
      let list = data.question.value.match(/"([^()]+)"/g) || []
      list = list.map(el => el && el.replace(/(")/g, '').trim())
      const parsedData = data.question.value.replace(/"([^()]+)"/g, '').split(' ')
      list = list.concat(parsedData).filter(el => el)
      return { search: list }
    },
    async searchData (parsedData, fullSq) {
      this.showTabs = true
      this.ready = false
      await this.getData(parsedData)
      this.ready = true
    },
    shouldSaveQuery (data) {
      let saveFlag = false
      Object.keys(data).forEach(category => {
        if (data[category].value) saveFlag = true
      })
      return saveFlag
    },
    toggleAlert (type, icon, text) {
      this.alert = {
        type,
        icon,
        text,
        isVisible: true
      }
      setTimeout(() => this.alert.isVisible = false, 3000)
    },
    async saveQuery (name, data) {
      const filters = { ...data }
      if (this.shouldSaveQuery(filters)) {
        const parsedData = _.cloneDeep(filters)
        Object.keys(parsedData).forEach(category => {
          if (!parsedData[category].value) {
            delete parsedData[category]
          }
        })
        let data = {
          metadata_query: JSON.stringify(parsedData),
          slug: name || `Search ${this.saved_searches.length + 1}`
        }
        let response = null
        try {
          response = await this.saveSearch({ userId: this.$auth.user().id, data, type: 'cics' })
          if (response.status === 200) {
            this.$refs.savedSearches.toggleBlink()
            this.toggleAlert('success', 'check-circle', 'Successfully saved current search.')
            this.saveMessage.error = false
            this.saveMessage.value = `Successfully saved current search as "${data.slug}".`
          }
        } catch (e) {
          this.saveMessage.error = true
          this.saveMessage.value = e.response.data.message
        }
      } else {
        this.saveMessage.error = true
        this.toggleAlert('danger', 'exclamation-circle', 'You can\'t save searches with empty filters!')
        this.saveMessage.value = 'You can\'t save searches with empty filters!'
      }
    },
    async removeSavedQuery (searchId) {
      await this.deleteSearch({ userId: this.$auth.user().id, data: { searchId }, type: 'cics' })
    },
    async resetComponentState () {
      this.toggleLoading(true)
      this.resetStoreFilters()
      await this.getSavedSearches({ userId: this.$auth.user().id, type: 'cics' })
      // get data
      this.filterFields = await this.getCicsFields()
      this.showTabs = false
      this.toggleLoading(false)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!to.params.allowLocationChange) {
      this.$refs.filters.togglePopup(to.name)
      next(false)
    } else {
      next()
    }
  },
  async mounted () {
    await this.resetComponentState()
  }
}
</script>

<style scoped>
.nav-link {
  margin-bottom: 0;
}

.el-table::before {
  height: 0 !important;
}

.search-filter {
  width: 100%;
  padding: 10px 20px;
  border-bottom: 1px solid #d1d4d7;
}

.search-filter:last-of-type {
  border-bottom: unset;
}

.tab-pane {
  min-height: 150px;
  max-height: 50vh;
  overflow: scroll;
  position: relative;
}

.saved-searches-header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.el-slider__bar {
  background-color: #20a8d8 !important;
}

.el-slider__button {
  border-color: #20a8d8 !important;
}

.el-checkbox__label {
  color: #20a8d8 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #20a8d8 !important;
  background-color: #20a8d8 !important;
}

.no-overflow {
  overflow: unset !important;
}

.tall-pane {
  max-height: 55vh !important;
}

.diagnostics {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  z-index: 1003;
  transition: width 0.2s linear;
}

.sidebard-toggled {
  width: calc(100% - 250px);
}

.description-header {
  color: #959799;
}
</style>
